import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import { getThemeStyles } from './theme';
export function getStyles(theme) {
  const themeStyles = getThemeStyles(theme);
  return mergeStyles(mainStyles, themeStyles);
}